<template>
	<div class="page">
		<!-- 轮播图容器 -->
		<div class="carousel-container">
			<div v-for="(item, index) in bgList" :key="item.pictureId"
				:class="['carousel-item', { 'active': currentIndex === index }]">
				<img :src="item.pictureUrl" alt="背景图" class="carousel-img" />
				<span class="carousel-title">{{item.pictureTitle||'暂无图片标题'}}</span>
			</div>
			<div class="carousel-dots flex-row-ac-je">
				<span v-for="(item, index) in bgList" :key="item.pictureId"
					:class="['dot', { 'active': currentIndex === index }]" @click="changeToIndex(index)"></span>
			</div>
		</div>

		<!-- 登录表单 -->
		<div class="page-footer flex-row-ac-jb">
			<div class="page-footer-lt flex-row-ac-js">
				<div class="form-item flex-row-ac-jb">
					<input class="input-area" placeholder="请输入手机号" type="tel" maxlength="11" v-model="phoneNumer" />
				</div>
				<div class="form-item flex-row-ac-jb">
					<input class="input-area" style="width: 150px;" placeholder="请输入验证码" type="tel" maxlength="6"
						v-model="vcodeNumer" />
					<div class="vcode-area flex-row-ac-jb">
						<span class="vcode-button" v-if="vcodeTime<1" @click="getVcode">获取验证码</span>
						<span class="vcode-time" v-else>{{`${vcodeTime}S`}}</span>
					</div>
				</div>
			</div>
			<div class="login-button" @click="toLogin">即刻登录</div>
		</div>
	</div>
</template>
<script>
export default {
  name: "Login",
  data() {
    return {
      bgList: [],
      currentIndex: 0,
      carouselTimer: null,
      vcodeTimer: null, // 验证码倒计时定时器
      phoneNumer: "",
      vcodeNumer: "",
      vcodeTime: 0,
    };
  },
  mounted() {
    this.getBgList();
  },
  // 在组件销毁前清除定时器
  beforeUnmount() {
    if (this.carouselTimer) {
      clearInterval(this.carouselTimer);
    }
    if (this.vcodeTimer) {
      clearInterval(this.vcodeTimer);
    }
  },
  methods: {
    getBgList() {
      let params = {};
      console.log("--api.getBgList--参数");
      console.log(params);
      this.$http.getBgList(params).then((res) => {
        console.log("--api.getBgList--结果");
        console.log(res)
        if (res.code != 0) {
          this.bgList = res.data;
        } else {
          // 如果接口请求失败，使用默认的图片数组
          this.bgList = [{
            "pictureId": 1,
            "pictureUrl": "http://learn.jamespang.cn:8086/c/buildingshare/bg1.png"
          }, {
            "pictureId": 2,
            "pictureUrl": "http://learn.jamespang.cn:8086/c/buildingshare/bg2.png"
          }, {
            "pictureId": 3,
            "pictureUrl": "http://learn.jamespang.cn:8086/c/buildingshare/bg3.png"
          }];
        }
        // 启动轮播
        this.startCarousel();
      }).finally(() => {});
    },
    // 启动轮播
    startCarousel() {
      // 清除之前的定时器
      if (this.carouselTimer) {
        clearInterval(this.carouselTimer);
      }
      // 设置新的定时器，每5秒切换一次图片
      this.carouselTimer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.bgList.length;
      }, 5000);
    },
    // 切换到指定索引的轮播图
    changeToIndex(index) {
      this.currentIndex = index;
      // 重新开始定时器
      this.startCarousel();
    },
    getVcode() {
      if (!this.phoneNumer || this.phoneNumer.length != 11 || this.phoneNumer[0] != '1') {
        this.$message.error('请输入正确的手机号');
        return;
      }
      let params = {
        phone: this.phoneNumer
      };
      console.log("--api.sms--参数");
      console.log(params);
      this.$http.sms(params).then((res) => {
        console.log("--api.sms--结果");
        console.log(res);
        if (res.code != 0) {
          this.$message.error(res.msg);
        } else {
          this.$message.success('验证码发送成功');
          // 启动60秒倒计时
          this.vcodeTime = 60;
          // 清除之前的定时器（如果存在）
          if (this.vcodeTimer) {
            clearInterval(this.vcodeTimer);
          }
          // 设置新的倒计时定时器
          this.vcodeTimer = setInterval(() => {
            this.vcodeTime--;
            // 倒计时结束，清除定时器
            if (this.vcodeTime <= 0) {
              if (this.vcodeTimer) {
                clearInterval(this.vcodeTimer);
                this.vcodeTimer = null;
              }
            }
          }, 1000);
        }
      });
    },
    toLogin() {
      if (!this.phoneNumer) {
        this.$message.error('请输入正确的手机号');
      } else if (!this.vcodeNumer) {
        this.$message.error('请输入正确的验证码');
      } else {
        this.doLogin();
      }
    },
    doLogin() {
      let params = {
        phone: this.phoneNumer,
        sms: this.vcodeNumer,
      };
      console.log("--api.login--参数");
      console.log(params);
      this.$http.login(params).then((res) => {
        console.log("--api.login--结果");
        console.log(res);
        //登录失败,先不讨论
        if (res.code != 0) {
          //iViewUi的友好提示
          this.$message.error(res.msg || `code: ${res.code}`);
          //登录成功
        } else {
          //设置Vuex登录标志为true，默认userLogin为false
          // this.$store.dispatch("userLogin", true);
          //Vuex在用户刷新的时候userLogin会回到默认值false，所以我们需要用到HTML5储存
          //我们设置一个名为Flag，值为isLogin的字段，作用是如果Flag有值且为isLogin的时候，证明用户已经登录了。
          localStorage.setItem("phone", this.phoneNumer);
          localStorage.setItem("token", res.data);
          // 同时更新Vuex状态
          this.$store.dispatch("login", {
            phone: this.phoneNumer,
            token: res.data
          });
          //Element Plus的友好提示
          this.$message.success('登录成功！');
          //登录成功后跳转到指定页面
          this.$router.push("/");
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
	.page {
		width: 100%;
		height: calc(100vh - 50px);
		background-color: #F7F8F9;
		position: relative;
		overflow: hidden;
	}

	/* 轮播图样式 */
	.carousel-container {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 0;

		.carousel-item {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			opacity: 0;
			transition: opacity 0.5s ease;

			&.active {
				opacity: 1;
			}

			.carousel-img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				z-index: 0;
			}

			.carousel-title {
				width: auto;
				position: absolute;
				left: 100px;
				bottom: 190px;
				z-index: 1;
				color: #FFFFFF;
			}
		}

		// 轮播图指示器样式
		.carousel-dots {
			position: absolute;
			bottom: 180px;
			right: 100px;
			z-index: 2;
			// padding: 10px;
			// background-color: rgba(0, 0, 0, 0.3);
			border-radius: 20px;
			gap: 8px;

			.dot {
				display: inline-block;
				width: 7px;
				height: 7px;
				border-radius: 50%;
				background-color: rgba(255, 255, 255, 0.5);
				cursor: pointer;
				transition: all 0.3s ease;

				&.active {
					width: 39px;
					border-radius: 3.5px;
					background-color: #FFFFFF;
				}

				&:hover {
					background-color: rgba(255, 255, 255, 0.8);
				}
			}
		}
	}


	.page-footer {
		width: 100%;
		height: 138px;
		padding: 0 100px;
		position: absolute;
		bottom: 0;
		z-index: 1;

		&::before {
			content: "";
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.6);
			-webkit-backdrop-filter: blur(8px);
			backdrop-filter: blur(8px);
			z-index: -1;
		}

		&-lt {
			width: 600rpx;

			.form-item {
				border-radius: 12px;
				background: rgba(255, 255, 255, 0.47);
				width: 250px;
				height: 60px;
				line-height: 60px;

				&:first-of-type {
					margin-right: 20px;
				}

				.input-area {
					width: 250px;
					background: rgba(255, 255, 255, 0);
					border: none;
					padding: 0 20px;
					height: 60px;
					line-height: 60px;
					color: #FFFFFF;
					font-size: 18px;
					letter-spacing: 2px;
				}

				.input-area::placeholder {
					letter-spacing: 0;
					/* 确保placeholder也应用相同的字母间距 */
					font-size: 16px;
					color: rgba(255, 255, 255, 0.4);
					/* 保持placeholder的半透明效果 */
				}

				.input-area:focus {
					border: none;
					outline: none;
				}

				.vcode-area {
					width: 100px;
					height: 60px;

					.vcode-button {
						width: 100px;
						padding-right: 20px;
						text-align: right;
						font-size: 16px;
						color: #FFE438;
						font-weight: 500;
						cursor: pointer;
					}

					.vcode-time {
						width: 100px;
						padding-right: 20px;
						text-align: right;
						font-size: 16px;
						color: #FFFFFF;
					}
				}
			}

		}

		.login-button {
			width: 230px;
			height: 60px;
			background: #0066FF;
			border-radius: 12px;
			text-align: center;
			line-height: 60px;
			color: #ffffff;
			font-size: 18px;
			user-select: none;
		}

		.login-button:hover {
			cursor: pointer;
		}
	}
</style>